<template>
  <div class="container">
    <h2 class="mt-5 mb-10">{{$t('issue_attendance')}}</h2>
    <div class="flagged">
      <v-card class="px-6 pb-0 mb-3 mt-4">
        <v-row>
          <v-col md="4" class="pb-0">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="dateFormatted"
                  :label="$t('select_date')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  color="primary"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" @change="onDateChange()" no-title scrollable :locale="$t('locale')"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col md="2" offset="1">
            <v-select
            v-model="selectedScheduleType"
            :items="shiftList"
            item-text="name"
            item-value="id"
            :label="$t('schedule_type')"
            @change="filterAttendanceByScheduleType($event)"
            ></v-select>
          </v-col>
          <v-col md="4"  offset="1">
            <v-text-field
              hide-details
              :label="$t('find_a_user')"
              prepend-icon="mdi-magnify"
              single-line
              v-model="search.keyword"
              @keyup.enter="fetchData()"
              :rules="[validator.alfaNumberNotRequired]"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card>

      <v-card min-height="800" max-height="100%" class="pb-0 overflow-y-auto mt-5">
        <v-data-table
          height="820"
          :loading="loading"
          :headers="headers"
          :items="activities"
          :server-items-length="totalData"
          :items-per-page="itemPerPage"
          :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }"
          :page="page"
          disable-sort
          @update:page="fetchData($event, itemPerPage)"
          @update:items-per-page="fetchData(page, $event)"
          :no-data-text="$t('no_data')"
        >
          <template v-slot:item.type="{ item }">
            <div v-if="item.type === 'in'">
              <v-icon color="success">mdi-location-enter</v-icon>
            </div>
            <div v-if="item.type === 'out'">
              <v-icon color="error">mdi-location-exit</v-icon>
            </div>
          </template>
          <template v-slot:item.reason="{ item }">
            <v-tooltip top v-if="item.reason_user != '-'">
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-bind="attrs"
                  v-on="on"
                  v-bind:class="checkReasonColor(item.reason)"
                  class="caption"
                >{{ checkReasonName(item.reason) }}</v-chip>
              </template>
              <span>{{ item.reason_user }}</span>
            </v-tooltip>
            <v-chip
              v-else
              v-bind:class="checkReasonColor(item.reason)"
              class="caption"
            >{{ checkReasonName(item.reason) }}</v-chip>
          </template>
          <template v-slot:item.note="{ item }">
            <v-tooltip top v-if="item.note_user != '-'">
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-bind="attrs"
                  v-on="on"
                  v-bind:class="checkNoteColor(item.note)"
                  class="caption"
                >{{ $t(item.note) }}</v-chip>
              </template>
              <span>{{ item.note_user }}</span>
            </v-tooltip>

            <v-chip v-else v-bind:class="checkNoteColor(item.note)" class="caption">{{ item.note }}</v-chip>
          </template>
          <template v-slot:item.time="{ item }">
            <div>{{ toHours(parseInt(item.time)) }}</div>
          </template>
          <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
export default {
  name: "Combined",
  data() {
    return {
      headers: [
        { text: this.$i18n.t('type'), value: "type" },
        { text: this.$i18n.t('user_name'), value: "user_name" },
        { text: this.$i18n.t('reason_time'), value: "reason" },
        { text: this.$i18n.t('note_location'), value: "note" },
        { text: this.$i18n.t('time'), value: "time" },
      ],
      selectedScheduleType: null,
      shiftList: [
        { id: null, name: this.$i18n.t('all') },
        { id: 0, name: 'Reguler' },
        { id: 1, name: 'Shift' },
      ],
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      activities: [],
      loading: false,
      search: { keyword: "" },
      reason_check: [],
      page: 1,
      shifting: null,
      itemPerPage: 10,
      totalData: 0,
      company_id: this.$store.state.company,
      date_search: moment().format("DD-MM-YYYY"),
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      userId: this.$store.state.user.id,
    };
  },
  computed: {
    dateFormatted() {
      return this.date ? moment(this.date).locale(this.$i18n.t('lang')).format("dddd, MMMM Do YYYY") : "";
    },
  },
  methods: {
    onDateChange() {
      this.menu = false;
      this.date_search = moment(this.date, "YYYY-MM-DD").format("DD-MM-YYYY");
      this.fetchData();
    },
    checkReasonName(reason) {
      switch (reason) {
        case '-': return null
        case 'In-Tolerance':
        case 'Meeting': return this.$i18n.t('In-Tolerance')

        case 'Others':
        case 'Incident': return this.$i18n.t('Late')
        case 'Checked-Out': return this.$i18n.t('Check-Out')
        case 'Early Check-Out': return this.$i18n.t('Early Check-Out')
        case 'On-Time': return this.$i18n.t('On-Time')
        default: return reason
      }
    },
    checkReasonColor(reason) {
      switch (reason) {
        case '-': return null
        case 'On-Time': return 'success'
        case 'In-Tolerance':
        case 'Meeting': return 'warning'
        default: return 'error'
      }
    },
    checkNoteColor(note) {
      switch (note) {
        case 'In-Area': return 'success'
        case 'GPS Error':
        case 'Meeting':
        case 'Work From Home': return 'warning'
        default: return 'error'
      }
    },
    toHours(time) {
      if (time) {
        return moment(time).format("HH:mm:ss");
      } else {
        return '-'
      }
    },
    fetchData(page = 1, itemPerPage = 10) {
      this.loading = true
      this.page = page;
      this.itemPerPage = itemPerPage
      const totalPageSend = itemPerPage < 1 ? this.totalData : itemPerPage;
      const start = this.page;

      let url = `${this.baseUrl}/summary/getsummarydaily?companyId=${this.company_id
        }&date=${this.date_search
        }&page=${start}&pageSize=${totalPageSend}&userId=${this.userId}`;
      if (this.search.keyword) {
        url = url + `&userName=${this.search.keyword}`;
      }
      if (this.shifting == 0){
          url = url + `&isShifting=false`;
      }else if (this.shifting == 1){
          url = url + `&isShifting=true`;
      }
      axios
        .get(url)
        .then((res) => {
          if (res.data.code == 200) {
            this.totalData = res.data.data.total;
            this.activities = res.data.data.data
          } else {
            this.totalData = 0
            this.activities = []
          }
          this.loading = false
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err); // TODO: Add error toast message
          this.loading = false
        });
    },
    async filterAttendanceByScheduleType(type) {
      this.selectedScheduleType = type;
      if(type == 0) {
        this.shifting = type;
      }
      else if(type == 1) {
        this.shifting = type;
      } else {
        this.shifting = null;
      }
      this.fetchData(1, this.itemPerPage)
    },
    mappingData(data) {
      const result = []
      data.forEach((tmp) => {
        if (tmp.type == 'out') {
          if (tmp.reason == '-' || tmp.reason == undefined) {
            tmp.reason = "Checked-Out"
          }
        }
        if (tmp.note != "In-Area" || tmp.reason !== "On-Time") {
          if (tmp.reason == "Checked-Out") {
            if (tmp.note != "In-Area" && tmp.note != '' && tmp.note != undefined) {
              result.push(tmp)
            }
          } else {
            if (tmp.note != '' && tmp.note != undefined) {
              result.push(tmp)
            }
          }
        }
      });
      return result
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
